import type { IDBPDatabase } from "idb";
import type { UserPreferences } from "../../types/core.js";
import type { MonologDB } from "../indexeddb-schema.js";

type WithDbOperation = <T>(
	onUnavailableMessage: string,
	fallback: () => T | Promise<T>,
	operation: (db: IDBPDatabase<MonologDB>) => Promise<T>,
) => Promise<T>;

export class PreferenceRepository {
	constructor(private readonly withDb: WithDbOperation) {}

	async savePreferences(
		userId: string,
		preferences: UserPreferences,
	): Promise<void> {
		return this.withDb(
			"Database not available, skipping preferences save",
			() => undefined,
			async (db) => {
				const preferencesWithId = { ...preferences, userId };
				await db.put("preferences", preferencesWithId);
			},
		);
	}

	async getPreferences(userId: string): Promise<UserPreferences | undefined> {
		return this.withDb(
			"Database not available, returning undefined for preferences",
			() => undefined,
			async (db) => db.get("preferences", userId),
		);
	}

	async getAllPreferences(): Promise<UserPreferences[]> {
		return this.withDb(
			"Database not available, returning empty array",
			() => [],
			async (db) => db.getAll("preferences"),
		);
	}
}
